import { render, staticRenderFns } from "./ConsumersNumbers.vue?vue&type=template&id=9b57e5cc&scoped=true"
import script from "./ConsumersNumbers.vue?vue&type=script&lang=js"
export * from "./ConsumersNumbers.vue?vue&type=script&lang=js"
import style0 from "./ConsumersNumbers.vue?vue&type=style&index=0&id=9b57e5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b57e5cc",
  null
  
)

export default component.exports